// Core lib dependencies.
import Immutable from 'seamless-immutable';

// Import action types.
import ActionTypes from './actionTypes.js';

// Config.
import Config from './config/config.js';

// Initial state.
const initialState = Immutable({
  showPrivacyPopup:         false,
  showCookiesDisabledModal: false,
});

/**
 * <pre>
 * PrivacyManagement module Reducer(s).
 *
 * Summary of responsibilities:
 *
 *  - responds to actions, receives current Redux state and modifies it accordingly.
 *
 * FYI:
 *
 * All {@link https://github.com/reactjs/redux|Redux} state modifications are handled using {@link https://facebook.github.io/immutable-js/|Immutable} objects and methods.
 * DO NOT DIRECTLY MODIFY THE REDUX STATE (Immutable should stop you from doing this, but just in case)!
 * </pre>
 *
 * @see {@link https://github.com/reactjs/redux|Redux Documentation}
 * @see {@link https://facebook.github.io/immutable-js/|Immutable Documentation}
 *
 * @memberof module:PrivacyManagement
 * @namespace
 *
 * @type {Object}
 */
const Reducer = {
  /**
   * Reducer for the PrivacyManagement actions.
   *
   * @param state: 	{object} The current Redux state.
   * @param action: 	{object} The current Redux action object.
   */
  rootReducer: (state = initialState, action) => {
    // Execute the appropriate logic based on the received action type.
    switch (action.type) {

      case ActionTypes.SHOW_PRIVACY_POPUP:
        state = state.setIn(['showPrivacyPopup'], true);
        return state;
        break;
      case ActionTypes.HIDE_PRIVACY_POPUP:
        state = state.setIn(['showPrivacyPopup'], false);
        return state;
        break;

      case ActionTypes.SHOW_COOKIES_DISABLED_MODAL:
        state = state.setIn(['showCookiesDisabledModal'], true);
        return state;
        break;
      case ActionTypes.HIDE_COOKIES_DISABLED_MODAL:
        state = state.setIn(['showCookiesDisabledModal'], false);
        return state;
        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Make sure to return a state even if no action was matched!
      default:
        return state;
    }
  },
};

export default Reducer;
